$(document).ready(function() {
    // Show loading spinner
    $('#loading').show();

    // Fetch data via AJAX
    // $.ajax({
    //     url: "https://jsonplaceholder.typicode.com/users",
    //     method: "GET",
    //     dataType: "json",
    //     success: function(data) {
    //         // Populate mobile card view
    //         data.forEach(function(item) {
    //             var card = `
    //                 <div class="card mb-3 mobile-card" style="display: none;">
    //                     <div class="card-body">
    //                         <h5 class="card-title">ID: ${item.id} - ${item.name}</h5>
    //                         <p class="card-text"><strong>Username:</strong> ${item.username}</p>
    //                         <p class="card-text"><strong>Email:</strong> ${item.email}</p>
    //                         <p class="card-text"><strong>Phone:</strong> ${item.phone}</p>
    //                         <p class="card-text"><strong>Website:</strong> ${item.website}</p>
    //                     </div>
    //                 </div>`;
    //             $('#mobileView').append(card);
    //         });

    //         // Mobile Pagination Setup
    //         var pageSize = 10;
    //         var currentPage = 1;
    //         var numPages = Math.ceil(data.length / pageSize);

    //         function showMobilePage(page) {
    //             currentPage = page;
    //             $('.mobile-card').hide();
    //             $('.mobile-card').slice((page - 1) * pageSize, page * pageSize).show();
    //             $('.page-item.number').removeClass('active');
    //             $('.page-item.number[data-page="' + page + '"]').addClass('active');
    //             updateMobilePagination();
    //         }

    //         function updateMobilePagination() {
    //             if (currentPage === 1) {
    //                 $('.page-item.prev').addClass('disabled');
    //             } else {
    //                 $('.page-item.prev').removeClass('disabled');
    //             }
    //             if (currentPage === numPages) {
    //                 $('.page-item.next').addClass('disabled');
    //             } else {
    //                 $('.page-item.next').removeClass('disabled');
    //             }
    //         }

    //         // Build mobile pagination
    //         var pagination = $('<nav aria-label="Mobile pagination"><ul class="pagination justify-content-center"></ul></nav>');
    //         var ul = pagination.find('ul');

    //         // Previous button
    //         var prev = $('<li class="page-item prev"><a class="page-link" href="#" aria-label="Previous"><span aria-hidden="true">&laquo;</span></a></li>');
    //         prev.click(function(e) {
    //             e.preventDefault();
    //             if (currentPage > 1) {
    //                 showMobilePage(currentPage - 1);
    //             }
    //         });
    //         ul.append(prev);

    //         // Page numbers
    //         for (var i = 1; i <= numPages; i++) {
    //             var li = $('<li class="page-item number" data-page="' + i + '"><a class="page-link" href="#">' + i + '</a></li>');
    //             li.click(function(e) {
    //                 e.preventDefault();
    //                 showMobilePage($(this).data('page'));
    //             });
    //             ul.append(li);
    //         }

    //         // Next button
    //         var next = $('<li class="page-item next"><a class="page-link" href="#" aria-label="Next"><span aria-hidden="true">&raquo;</span></a></li>');
    //         next.click(function(e) {
    //             e.preventDefault();
    //             if (currentPage < numPages) {
    //                 showMobilePage(currentPage + 1);
    //             }
    //         });
    //         ul.append(next);

    //         $('#mobilePagination').append(pagination);

    //         // Show first page if data exists
    //         if (numPages > 0) {
    //             showMobilePage(1);
    //         }

    //         // Initialize DataTable for desktop view
    //         $('#exampleTable').DataTable({
    //             "data": data,
    //             "columns": [
    //                 { "data": "id" },
    //                 { "data": "name" },
    //                 { "data": "username" },
    //                 { "data": "email" },
    //                 { "data": "phone" },
    //                 { "data": "website" }
    //             ],
    //             "paging": true,      // Enable pagination
    //             "ordering": true,    // Enable sorting
    //             "info": true,        // Show table info
    //             "searching": true,   // Enable search
    //             "lengthChange": false, // Remove show entries input
    //             "pageLength": 10,    // Default 10 entries per page
    //             "processing": true   // Built-in processing indicator
    //         });

    //         // Hide loading spinner
    //         $('#loading').hide();
    //     },
    //     error: function() {
    //         // Hide loading on error
    //         $('#loading').hide();
    //         alert("Error fetching data.");
    //     }
    // });
});